import { createSlice } from "@reduxjs/toolkit";

const isLoggedIn = false;

const initialUserDetails = {
    createdOn: '',
    dcode: '',
    email: '',
    id: 0,
    lastLogin: '',
    mobileNo: '',
    password: '',
    srocode: '',
    status: '',
    thumb: '',
    userDesig: '',
    userRole: '',
    username: '',
}

const initialLoginState = {
    isLoggedIn: false,
    userDetails: initialUserDetails
}

const authSlice = createSlice({
    name: 'authSlice',
    initialState: initialLoginState,
    reducers: {
        logIn(state, action) {
            state.isLoggedIn = true;
            state.userDetails = action.payload;
        },
        logOut(state) {
            state.isLoggedIn = false;
            state.userDetails = initialUserDetails;
        }
    }
});

export const { logIn, logOut } = authSlice.actions;
export const isLoggenIn =(state) => state.auth.isLoggedIn
export default authSlice.reducer;
